import { AxiosRequestConfig } from "axios";
import client from "libs/HttpClient";

/**
 * Represents the structure of a request for listing Translation.
 */
interface ListTranslationRequest {
  queryKey: [number, string];
}

/**
 * Service class for handling Translation.
 */
class TranslationService {
  static listTranslation(request: ListTranslationRequest) {
    const page_no = request.queryKey[0];
    const searchText = request.queryKey[1];

    return client.get(
      `admin/translation/list?page=${page_no}&search_text=${searchText}`,
      request as AxiosRequestConfig
    );
  }

  /**
   * Adds a new Translation based on the provided request.
   *
   * @param request - The request parameters for adding a Translation.
   * @returns A Promise that resolves to the Axios response for the add Translation request.
   */
  static addTranslation(request: any) {
    return client.post("admin/translation/add", request);
  }

  /**
   * Updates the details of a Translation based on the provided request.
   *
   * @param request - The request parameters for updating a Translation.
   * @returns A Promise that resolves to the Axios response for the update Translation request.
   */
  static updateTranslation(request: any) {
    return client.post("admin/translation/edit/", request);
  }

  /**
   * Retrieves the details of a Translation based on the provided parameters.
   *
   * @param params - The parameters for retrieving the Translation details.
   * @returns A Promise that resolves to the Axios response containing the Translation details.
   */
  static viewTranslation(params: any) {
    return client.get("admin/translation/get", { params });
  }

  /**
   * Deletes a translation based on the provided parameters.
   *
   * @param params - The parameters for deleting the Translation.
   * @returns A Promise that resolves to the Axios response for the delete Translation request.
   */
  static deleteTranslation(params: any) {
    return client.delete("/admin/translation/delete/", { params });
  }

  /**
   * Updates the details of a Translation based on the provided request.
   *
   * @param request - The request parameters for updating a Translation.
   * @returns A Promise that resolves to the Axios response for the update Translation request.
   */
  static syncTranslation(request: any) {
    return client.put(`admin/translation/sync-data`, request);
  }
}

export { TranslationService };
